import * as React from "react";
const SvgOthers = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.38 22.18",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "others_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "others_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M25.75 14.53 13.52 9A.6.6 0 0 0 13 9L.63 14.53a1.07 1.07 0 0 0 0 2l12.42 5.65a.56.56 0 0 0 .49 0l12.22-5.64a1.07 1.07 0 0 0-.01-2.01M13.3 19.78l-9.42-4.29 9.42-4.26 9.38 4.27Z",
	style: { fill: "#706f6f" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m22.68 15.5-9.38 4.28-9.42-4.29 9.42-4.26z",
	style: { fill: "#c6c6c6" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25.75 10.09 13.52 4.57a.6.6 0 0 0-.49 0L.63 10.09a1.07 1.07 0 0 0 0 1.91l12.42 5.65a.56.56 0 0 0 .49 0L25.76 12a1.07 1.07 0 0 0-.01-1.91M13.3 15.34l-9.42-4.29 9.42-4.26 9.38 4.27Z",
	style: { fill: "#706f6f" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m22.68 11.06-9.38 4.28-9.42-4.29 9.42-4.26z",
	style: { fill: "#e6e6e6" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M25.75 5.57 13.52.05a.6.6 0 0 0-.49 0L.63 5.57a1.07 1.07 0 0 0 0 1.95l12.42 5.65a.56.56 0 0 0 .49 0l12.22-5.65a1.07 1.07 0 0 0-.01-1.95M13.3 10.82 3.88 6.53l9.42-4.26 9.38 4.27Z",
	style: { fill: "#706f6f" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "m22.68 6.54-9.38 4.28-9.42-4.29 9.42-4.26z",
	style: { fill: "#f2f2f2" }
}))));
export default SvgOthers;
